import classnames from 'classnames';
import * as React from 'react';
import { createElement } from 'react';
import TouchFeedback from 'rmc-feedback';
import { BlockSelectPropsType } from './PropsType';
import './style.less';
BlockSelect.defaultProps = {
    prefixCls: 'im-block-select',
    selectedIndex: [0],
    disabled: [],
    data: [],
    style: {},
    type: 'radio',
    size: 'M',
    align: "center"
};
function BlockSelect(props) {
    const { prefixCls, data = [], type, size, className, style, disabled = [], onChange, onValueChange, aliquot, align, } = props;
    const [selectedIndex, setSelectedIndex] = React.useState(props.selectedIndex || []);
    React.useEffect(() => {
        setSelectedIndex(props.selectedIndex || []);
    }, [props.selectedIndex, data.length]);
    const onClick = (e, index, item) => {
        let selectedIndexArr = selectedIndex || [];
        if (type === 'radio') {
            if (selectedIndexArr[0] !== index) {
                selectedIndexArr = [index];
            }
            else {
                selectedIndexArr = [];
            }
        }
        else if (type === 'checkbox') {
            if (selectedIndexArr.indexOf(index) === -1) {
                selectedIndexArr.push(index);
            }
            else {
                selectedIndexArr.splice(selectedIndexArr.indexOf(index), 1);
            }
        }
        selectedIndexArr.sort((a, b) => {
            return a - b;
        });
        e.nativeEvent.selectedBlockIndex = selectedIndexArr;
        e.nativeEvent = e.nativeEvent ? e.nativeEvent : {};
        e.nativeEvent.item = item;
        if (onChange) {
            onChange(e);
        }
        if (onValueChange) {
            onValueChange(item);
        }
        setSelectedIndex(JSON.parse(JSON.stringify(selectedIndexArr)));
    };
    let remainder;
    const addObj = (arr, num) => {
        remainder = arr.length % num;
        if (remainder !== 0) {
            const addArrNum = num - remainder;
            for (let i = 0; i < addArrNum; i++) {
                arr.push({});
            }
        }
        return arr;
    };
    switch (aliquot) {
        case 3:
            addObj(data, 3);
            break;
        case 4:
            addObj(data, 4);
            break;
        case 5:
            addObj(data, 5);
            break;
        case 6:
            addObj(data, 6);
            break;
        default:
            break;
    }
    const isLargeScreen = typeof window !== 'undefined' && window.innerWidth > 500;
    const renderBlockItem = (idx, item, selected, disabled) => {
        const truncatedLabel = size === 'S' && aliquot === 6 && item.label
            ? item.label.slice(0, 3)
            : item.label;
        const itemCls = classnames(`${prefixCls}-item`, {
            [`${prefixCls}-item-selected`]: selected,
            [`${prefixCls}-item-s`]: size === 'S',
            [`${prefixCls}-item-m`]: size === 'M',
            [`${prefixCls}-item-l`]: size === 'L',
            [`${prefixCls}-item-xl`]: size === 'XL',
            [`${prefixCls}-item-self`]: size === 'self',
            [`${prefixCls}-item-desc`]: item.desc || item.desc1,
            [`${prefixCls}-item-icon`]: item.icon && (!(item.desc && item.desc1) && (item.desc || item.desc1)),
            [`${prefixCls}-item-disabled`]: disabled,
            [`${prefixCls}-item-adaptiveWidth`]: className === 'adaptiveWidth',
            [`${prefixCls}-item-aliquot-3`]: aliquot === 3,
            [`${prefixCls}-item-aliquot-4`]: aliquot === 4,
            [`${prefixCls}-item-aliquot-5`]: aliquot === 5,
            [`${prefixCls}-item-aliquot-6`]: aliquot === 6,
            [`${prefixCls}-item-aliquot-6width`]: aliquot === 6 && isLargeScreen,
        });
        return (createElement(TouchFeedback, { key: idx, disabled: disabled, activeClassName: `${prefixCls}-item-active` },
            createElement("div", { className: itemCls, style: !item.label ? { visibility: 'hidden' } : {}, role: "tab", "aria-selected": selected && !disabled, "aria-disabled": disabled, onClick: disabled ? undefined : e => onClick(e, idx, item) },
                truncatedLabel,
                createElement("div", { className: `${prefixCls}-item-icon-desc-text` },
                    createElement("div", { className: `${prefixCls}-item-desc-icon` },
                        createElement("img", { src: item.icon, alt: "" })),
                    item.desc ? (createElement("div", { className: `${prefixCls}-item-desc-text` }, item.desc)) : null,
                    item.desc1 ? (createElement("div", { className: `${prefixCls}-item-desc-text` }, item.desc1)) : null))));
    };
    const wrapCls = classnames(className, prefixCls, {});
    const justifyContentValue = (isLargeScreen && aliquot == 6) ? 'center' : align == 'center' ? 'space-between' : align == 'left' ? 'flex-start' : align == 'right' ? 'flex-end' : 'auto';
    return (createElement("div", { className: wrapCls, style: {
            justifyContent: justifyContentValue,
            ...style
        }, role: "tablist" }, data.map((value, idx) => {
        return renderBlockItem(idx, value, selectedIndex?.indexOf(idx) > -1, disabled.indexOf(idx) > -1);
    })));
}
export { BlockSelectPropsType };
export default BlockSelect;
